(function(){
  "use strict";
  try {
    var slides = [{"title":"Margaux-Rita","kicker":"Smoked Wine Margarita","text":"Tequila, Cabernet, and lime in a smoky margarita riff.","recipe":"1.5 oz tequila + 0.75 oz Cordial Craft + 0.5 oz Cabernet Sauvignon","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-wine-alottasmoke-2-9425932fc6.webp?v=1787604063","alt":"Margaux-Rita cocktail with rosemary smoke swirling around the glass","width":2994,"height":3992},{"title":"Skinny Pisco Sour","kicker":"Classic Sour Structure","text":"A pisco sour with bright lime character and classic egg-white texture.","recipe":"2 oz pisco + 1 oz Cordial Craft + 1 freshly separated egg white","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-img-1998-3-825743c3ca.webp?v=1787604064","alt":"Skinny Pisco Sour made with Cordial Craft, pisco, and egg white foam","width":3024,"height":4032},{"title":"S.P.A. Highball","kicker":"Sparkling Highball","text":"Cucumber-mint vodka, lime, and bubbles in a crisp highball that drinks light and clean.","recipe":"2 oz cucumber-mint vodka + 0.75 oz Cordial Craft + 4 to 6 oz carbonated water","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-spa-highball-horizon-corrected-20260912.png?v=1789194299","alt":"S.P.A. Highball with a cucumber ribbon and fresh mint in a tall glass","width":1086,"height":1448},{"title":"Skinny Elderflower-Rose Gimlet","kicker":"Floral Gimlet","text":"Floral gin and lime in a polished gimlet that stays bright instead of sweet.","recipe":"2 oz elderflower-rose gin + 1 oz Cordial Craft","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-img-4547-6224785f0a.webp?v=1787604063","alt":"Skinny Elderflower-Rose Gimlet made with elderflower-rose gin and Cordial Craft","width":2795,"height":3699},{"title":"Hibiscus-Citrus Highball","kicker":"Tequila Highball","text":"Grapefruit-hibiscus tequila, lime, and bubbles in a bright highball with a dry finish.","recipe":"2 oz grapefruit-hibiscus tequila + 0.75 oz Cordial Craft + optional orange bitters + carbonated water","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-21seedshibiscus-bef2ecb561.webp?v=1787604063","alt":"Hibiscus-Citrus Highball made with grapefruit-hibiscus tequila, Cordial Craft, optional orange bitters, and carbonated water","width":2954,"height":3966},{"title":"Lean Flamingo","kicker":"Tropical Bitter Build","text":"Dark rum, pineapple, Campari, and lime in a vivid tropical drink with bitter depth.","recipe":"1.5 oz dark rum + 1.5 oz pineapple juice + 0.75 oz Campari + 0.5 oz Cordial Craft","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-bestparadise-2-8c8db6e6c6.webp?v=1787604063","alt":"Lean Flamingo cocktail made with dark rum, pineapple juice, Campari, and Cordial Craft","width":3024,"height":4032},{"title":"Tamarindo Verde","kicker":"Spicy Tamarind Margarita","text":"Tequila, spicy tamarind liqueur, mint, and lime in a bright, savory margarita riff.","recipe":"1.5 oz tequila blanco + 0.75 oz spicy tamarind liqueur + 0.75 oz Cordial Craft + mint","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-verdefrontangle-eb8ee49327.webp?v=1787604064","alt":"Tamarindo Verde cocktail made with tequila, spicy tamarind liqueur, Cordial Craft, and mint","width":3024,"height":4032},{"title":"Skinny Mai Tai","kicker":"Tropical Rum Classic","text":"Jamaican rum, dry curaçao, almond, and lime in a leaner tropical drink.","recipe":"2 oz Jamaican rum + 1 oz Cordial Craft + 0.5 oz dry curaçao + 0.75 oz almond milk + optional toasted almond bitters","image":"https://cdn.shopify.com/s/files/1/0740/0485/7068/files/cc-img-4646-c7983da311.webp?v=1787604064","alt":"Skinny Mai Tai made with Jamaican rum, Cordial Craft, orange liqueur, almond milk, and toasted almond bitters","width":2548,"height":3397}];
    var leadCarousel = document.querySelector("[data-cc10-carousel][data-cc10-lead]");
    if (leadCarousel) {
      var leadImage = leadCarousel.querySelector("[data-cc10-slide-image]");
      var leadText = function(selector) { return leadCarousel.querySelector(selector).textContent.trim(); };
      slides.unshift({
        title: leadText("[data-cc10-slide-title]"),
        kicker: leadText("[data-cc10-slide-kicker]"),
        text: leadText("[data-cc10-slide-text]"),
        recipe: leadText("[data-cc10-slide-recipe]"),
        image: leadImage.getAttribute("src"),
        alt: leadImage.alt,
        width: Number(leadImage.getAttribute("width")),
        height: Number(leadImage.getAttribute("height"))
      });
    }
    function closest(node, selector) {
      if (node && node.nodeType !== 1) node = node.parentElement;
      while (node && node.nodeType === 1) {
        if (node.matches && node.matches(selector)) return node;
        node = node.parentElement;
      }
      return null;
    }
    function indexOf(value) {
      var index = parseInt(value, 10);
      if (!Number.isFinite(index)) index = 0;
      return ((index % slides.length) + slides.length) % slides.length;
    }
    function currentIndex(carousel) {
      return indexOf(carousel.getAttribute("data-cc10-index") || "0");
    }
    function render(carousel, value) {
      if (!carousel || !slides.length) return;
      var index = indexOf(value);
      var slide = slides[index];
      carousel.setAttribute("data-cc10-index", String(index));
      carousel.removeAttribute("data-cc10-failed");
      var image = carousel.querySelector("[data-cc10-slide-image]");
      var kicker = carousel.querySelector("[data-cc10-slide-kicker]");
      var title = carousel.querySelector("[data-cc10-slide-title]");
      var text = carousel.querySelector("[data-cc10-slide-text]");
      var recipe = carousel.querySelector("[data-cc10-slide-recipe]");
      var status = carousel.querySelector("[data-cc10-status]");
      var select = carousel.querySelector("[data-cc10-select]");
      if (image) {
        var imageWidths = [480, 720, 960, 1200, 1600];
        var imageMaxWidth = Math.min(slide.width, 1600);
        imageWidths = imageWidths.filter(function(width) { return width <= imageMaxWidth; });
        if (imageWidths[imageWidths.length - 1] !== imageMaxWidth) imageWidths.push(imageMaxWidth);
        var imageURL = function(width) {
          var url = new URL(slide.image);
          url.searchParams.set("width", String(width));
          return url.href;
        };
        image.alt = slide.alt;
        image.width = slide.width;
        image.height = slide.height;
        image.srcset = imageWidths.map(function(width) { return imageURL(width) + " " + width + "w"; }).join(", ");
        image.src = imageURL(imageMaxWidth);
        image.style.opacity = "1";
        image.style.display = "";
      }
      if (kicker) kicker.textContent = slide.kicker;
      if (title) title.textContent = slide.title;
      if (text) text.textContent = slide.text;
      if (recipe) recipe.textContent = slide.recipe;
      if (status) status.textContent = "Showing " + slide.title + ".";
      if (select) select.value = String(index);
    }
    function prepareCarousel(carousel) {
      if (!carousel) return;
      if (!carousel.getAttribute("data-cc10-index")) {
        carousel.setAttribute("data-cc10-index", "0");
      }
      var select = carousel.querySelector("[data-cc10-select]");
      if (select) select.value = String(currentIndex(carousel));
      if (carousel.getAttribute("data-cc10-bound") === "true") return;
      carousel.setAttribute("data-cc10-bound", "true");
      carousel.addEventListener("click", function(event) {
        var prev = closest(event.target, "[data-cc10-prev]");
        var next = closest(event.target, "[data-cc10-next]");
        if (!prev && !next) return;
        event.preventDefault();
        var index = currentIndex(carousel);
        if (prev) {
          render(carousel, index - 1);
          return;
        }
        if (next) {
          render(carousel, index + 1);
          return;
        }
      });
      carousel.addEventListener("change", function(event) {
        var target = event.target;
        if (target && target.matches && target.matches("[data-cc10-select]")) {
          render(carousel, target.value);
        }
      });
      carousel.addEventListener("error", function(event) {
        var target = event.target;
        if (!target || !target.matches || !target.matches("[data-cc10-slide-image]")) return;
        carousel.setAttribute("data-cc10-failed", "true");
      }, true);
    }
    function initializeCarousels() {
      document.querySelectorAll("[data-cc10-carousel]").forEach(prepareCarousel);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeCarousels, { once: true });
    } else {
      initializeCarousels();
    }
  } catch (error) {
    window.__cc10CarouselErrorV105 = error;
  }
})();
